import { css } from '@emotion/react'

export const fontFamily = {
  spoqaHanSans: css`
    font-family:
      'Spoqa Han Sans Neo',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      Oxygen,
      Ubuntu,
      Cantarell,
      'Open Sans',
      'Helvetica Neue',
      sans-serif;
  `,
  montserrat: css`
    font-family:
      Montserrat,
      'Spoqa Han Sans Neo',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      Oxygen,
      Ubuntu,
      Cantarell,
      'Open Sans',
      'Helvetica Neue',
      sans-serif;
  `,
  pretendard: css`
    font-family: Pretendard, system-ui, sans-serif;
  `,
}
